var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 43.582,
  height: 43.582
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clear_svg__cls-2{fill:none;stroke:#157dc3;stroke-linecap:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "clear_svg__\\uADF8\\uB8F9_672",
  transform: "rotate(-45 -331.471 567.799)"
}, /*#__PURE__*/React.createElement("g", {
  id: "clear_svg__\\uADF8\\uB8F9_635",
  transform: "translate(289 416.099)"
}, /*#__PURE__*/React.createElement("path", {
  id: "clear_svg__\\uD328\\uC2A4_266",
  fill: "#fff",
  d: "M15.409 0A15.409 15.409 0 1 1 0 15.409 15.41 15.41 0 0 1 15.409 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "clear_svg__\\uD328\\uC2A4_272",
  d: "M697.72 7416.5h15.9",
  className: "clear_svg__cls-2",
  transform: "translate(-401.287 -6984.993)"
}), /*#__PURE__*/React.createElement("path", {
  id: "clear_svg__\\uD328\\uC2A4_273",
  d: "M0 0h15.9",
  className: "clear_svg__cls-2",
  transform: "rotate(-90 371.924 67.536)"
}))));
export { SvgClear as ReactComponent };
export default __webpack_public_path__ + "static/media/clear.02e83550.svg";